import ContinueButton from '@app-studio-web/ui/components/ContinueButton'
import Heading from '@app-studio-web/ui/components/Heading'
import PageLayout from '@app-studio-web/ui/components/PageLayout'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'
import { SubmitTarget } from 'react-router-dom/dist/dom'
import { twMerge } from 'tailwind-merge'

interface RatingPageProps {
  maxSubtitle: string
  minSubtitle: string
  subtitle?: string
  title: string
  preselectedValue?: string | number
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void
}
export default function RatingPage({
  maxSubtitle,
  minSubtitle,
  subtitle,
  title,
  preselectedValue,
  onSubmit,
}: RatingPageProps) {
  const [selectedRating, setSelectedRating] = useState<
    string | number | undefined
  >(preselectedValue)

  const { t } = useTranslation()
  const submit = useSubmit()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (onSubmit) {
      onSubmit(event as unknown as React.FormEvent<HTMLFormElement>)
    }
    submit(event.target as SubmitTarget)
  }

  return (
    <PageLayout>
      <div className="grow">
        <Heading title={t(title)} />
      </div>

      <Form
        className="flex grow flex-col justify-between gap-14"
        method="post"
        onSubmit={handleSubmit}
      >
        <div className="mx-auto space-y-3">
          <div className="flex items-center justify-center gap-3">
            {[1, 2, 3, 4, 5].map((rating) => (
              <label
                className={twMerge(
                  'font-headline cursor-pointer rounded-lg px-5 py-3 hover:opacity-80 hover:drop-shadow-lg',
                  selectedRating === rating
                    ? 'bg-primary drop-shadow-primary hover:drop-shadow-primary text-white drop-shadow-xl hover:drop-shadow-xl'
                    : 'text-custom-black bg-white',
                )}
                key={rating}
              >
                <input
                  className="hidden"
                  name="rating"
                  onChange={() => setSelectedRating(rating)}
                  type="radio"
                  value={`${rating}`}
                />

                {rating}
              </label>
            ))}
          </div>

          <div className="flex justify-between text-sm text-[#AFAFAF]">
            <p>{t(minSubtitle)}</p>

            <p>{t(maxSubtitle)}</p>
          </div>
        </div>

        {subtitle && (
          <div className="flex items-center justify-center gap-4 rounded-full border border-[#DFE0E2] bg-white p-4">
            <span className="text-sm font-medium text-[#222222]">
              {t(subtitle)}
            </span>
          </div>
        )}

        <div
          className={twMerge(
            'sticky bottom-14 shrink-0 transition-all duration-300',
            selectedRating === undefined
              ? 'invisible opacity-0'
              : 'visible opacity-100',
          )}
        >
          <ContinueButton />
        </div>
      </Form>
    </PageLayout>
  )
}
